import Auth from "./auth";

class SpotifyAPI {
  static getSpotifyUser = async () => {
    const response = await fetch("https://api.spotify.com/v1/me", {
      headers: {
        "Content-type": "application/json",
        Authorization: `Bearer ${await Auth.getAccessToken()}`,
      },
    });
    return await response.json();
  };

  static getSpotifyTracks = async () => {
    let tracks = [];
    let nextURL = "https://api.spotify.com/v1/me/tracks?offset=0&limit=50";
    do {
      const response = await fetch(nextURL, {
        headers: {
          "Content-type": "application/json",
          Authorization: `Bearer ${await Auth.getAccessToken()}`,
        },
      });
      const data = await response.json();
      tracks = tracks.concat(data.items);
      nextURL = data.next;
    } while (nextURL !== null);
    return tracks;
  };

  static getSpotifyRelatedArtists = async (artistId) => {
    const response = await fetch(
      `https://api.spotify.com/v1/artists/${artistId}/related-artists`,
      {
        headers: {
          "Content-type": "application/json",
          Authorization: `Bearer ${await Auth.getAccessToken()}`,
        },
      }
    );
    return await response.json();
  };

  static getSpotifyPopularTracks = async (artistId) => {
    const response = await fetch(
      `https://api.spotify.com/v1/artists/${artistId}/top-tracks?market=AR`,
      {
        headers: {
          "Content-type": "application/json",
          Authorization: `Bearer ${await Auth.getAccessToken()}`,
        },
      }
    );
    const data = await response.json();
    return data.tracks.filter((track) => track.popularity >= 70);
  };

  static createSpotifyPlayList = async (
    artistId,
    playlistName,
    playlistDescription
  ) => {
    let tracks = [];
    let uris = [];

    // get related artists
    let data = await this.getSpotifyRelatedArtists(artistId);

    // get popular tracks for each related artist
    for (const artist of data.artists) {
      tracks = tracks.concat(await this.getSpotifyPopularTracks(artist.id));
    }

    // get the uri for each track (required for the playlist)
    for (const track of tracks) {
      uris.push(track.uri);
    }

    // create the playlist
    let response = await fetch(
      `https://api.spotify.com/v1/users/${sessionStorage.user_id}/playlists`,
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-type": "application/json",
          Authorization: `Bearer ${await Auth.getAccessToken()}`,
        },
        body: JSON.stringify({
          name: playlistName,
          description: playlistDescription,
          public: false,
        }),
      }
    );

    data = await response.json();

    // populate the playlist
    response = await fetch(
      `https://api.spotify.com/v1/playlists/${data.id}/tracks`,
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-type": "application/json",
          Authorization: `Bearer ${await Auth.getAccessToken()}`,
        },
        body: JSON.stringify({ uris: [...new Set(uris)], position: 0 }),
      }
    );

    return await response.json();
  };

  static playTrack = async (spotify_uri, player_id, position_offset) => {
    await fetch(
      `https://api.spotify.com/v1/me/player/play?device_id=${player_id}`,
      {
        method: "PUT",
        body: JSON.stringify({
          uris: spotify_uri,
          offset: { position: position_offset },
        }),
        headers: {
          "Content-type": "application/json",
          Authorization: `Bearer ${await Auth.getAccessToken()}`,
        },
      }
    );
  };
}

export default SpotifyAPI;
